module.exports = __webpack_public_path__ + "static/media/loader.64c90eb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/PreLoaders/loader.svg
// module id = 88
// module chunks = 1